/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Transcript_Group_NameInputs */

const en_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript`)
};

const fr_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript`)
};

const it_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стенограмма`)
};

const es_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字稿`)
};

const ja_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプト`)
};

const hi_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_iframe_remote_transcript_group_name = /** @type {(inputs: Iframe_Remote_Transcript_Group_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {Iframe_Remote_Transcript_Group_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_transcript_group_name = /** @type {((inputs?: Iframe_Remote_Transcript_Group_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Transcript_Group_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_transcript_group_name(inputs)
	if (locale === "de") return de_iframe_remote_transcript_group_name(inputs)
	if (locale === "it") return it_iframe_remote_transcript_group_name(inputs)
	if (locale === "ru") return ru_iframe_remote_transcript_group_name(inputs)
	if (locale === "es") return es_iframe_remote_transcript_group_name(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_transcript_group_name(inputs)
	if (locale === "ja") return ja_iframe_remote_transcript_group_name(inputs)
	if (locale === "hi") return hi_iframe_remote_transcript_group_name(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_transcript_group_name(inputs)
	return en_iframe_remote_transcript_group_name(inputs)
});